import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
import { getDevicesFromStatistics } from '../utils/getDevicesFromStatistics';
export var initMobileDeviceFullStore = mutatorAction('initMobileDeviceFullStore', function (deviceStatistics, casMailbox) {
    var store = mobileDeviceFullStore();
    store.devices = getDevicesFromStatistics(deviceStatistics);
    store.deviceStatistics = deviceStatistics;
    store.casMailbox = casMailbox;
    store.isLoggingEnabled = casMailbox.ActiveSyncDebugLogging;
    store.notSendReadReceipt = casMailbox.ActiveSyncSuppressReadReceipt;
    store.selected = -1;
    store.isLoggingOpen = false;
    store.isDetailsOpen = false;
    store.isLoggingEnabledDirty = false;
    store.isNotSendReadReceiptDirty = false;
    store.isDevicesDirty = false;
});
//# sourceMappingURL=initMobileDeviceFullStore.js.map